export default "__VITE_ASSET__BoJgUfXt__"